import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ExperimentationService } from 'src/app/shared/experimentation.service';
import { ROUTES_URLS } from '../constants';
import { StorageService } from '../storage.service';

@Injectable()
export class DocumentApprovalFlowGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly experimentationService: ExperimentationService,
    private readonly storageService: StorageService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const isV2TranscriptionFlow = route.routeConfig.path === ROUTES_URLS['document-transcription-v2'];
    const userId = JSON.parse(this.storageService.get('userInfo') || "{}")?.id;

    if(userId) {
      return this.experimentationService.showTranscriptionRevampVersion(userId).pipe(
        map((resp: boolean) => this.handleRevampVersionRedirection(isV2TranscriptionFlow, resp, state, route)
      ));
    } else {
      return false;
    }
  }

  handleRevampVersionRedirection(isV2TranscriptionFlow, resp, state, route) {
    if(isV2TranscriptionFlow) {
      if(!resp) {
        const urlPath = state.url.split('?')?.[0];
        const urlTokens = urlPath?.split('/');

        if(urlTokens.length > 0) {
          this.router.navigate([`approve-documents/${urlTokens?.[urlTokens.length - 1]}/personal/${urlTokens?.[urlTokens.length - 2]}`], {
            queryParams: route.queryParams
          });
        } else {
          return true;
        }
      }
      return true;
    } else {
      if(resp) {
        const urlPath = state.url.split('?')?.[0];
        const urlTokens = urlPath?.split('/');

        if(urlTokens.length > 0) {
          this.router.navigate([`${ROUTES_URLS['document-transcription-v2']}/${urlTokens?.[urlTokens.length - 1]}/${urlTokens?.[urlTokens.length - 3]}`], {
            queryParams: route.queryParams
          });
        } else {
          return true;
        }
      }

      return true;
    }
  }
}
